
const itemPerPage = 25

const state = {
  currentPage: 1,
  objectCount: 0
}

const getters = {
  getCurrentPage: state => state.currentPage,
  hasPrev: state => state.currentPage > 1,
  hasSecondPrev: state => state.currentPage > 2,
  hasNext: state => state.currentPage * itemPerPage < state.objectCount,
  hasSecondNext: state => (state.currentPage + 1) * itemPerPage < state.objectCount,
  getFromItem: state => {
    if (!state.objectCount) {
      return 0
    }
    return (state.currentPage - 1) * itemPerPage + 1
  },
  getToItem: state => {
    if (!state.objectCount) {
      return 0
    }
    return Math.min(state.currentPage * itemPerPage, state.objectCount)
  },
  hasAnyPage: state => state.objectCount > 0
}

const mutations = {
  resetPagination (state) {
    state.currentPage = 1
    state.objectCount = 0
  },

  setObjectCount (state, objectCount) {
    state.objectCount = objectCount
    if (objectCount < (state.currentPage - 1) * itemPerPage) {
      state.currentPage = Math.floor(objectCount / itemPerPage) + 1
    }
  },

  setPage (state, pageNum) {
    if (pageNum >= 1 && (pageNum - 1) * itemPerPage < state.objectCount) {
      state.currentPage = pageNum
    }
  }
}

export default { state, getters, mutations }



// WEBPACK FOOTER //
// ./src/store/modules/common/pagination.js